import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Heart = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="94" viewBox="0 0 94 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.4048 40.9479C-1.9456 31.5984 -1.9456 16.4381 7.4048 7.08771C16.7542 -2.26269 31.9136 -2.26269 41.264 7.08771L46.9481 12.7719L52.6314 7.08864C61.9818 -2.26176 77.1411 -2.26176 86.4906 7.08864C95.841 16.439 95.841 31.5984 86.4906 40.9478L46.9482 80.4912L7.4048 40.9479Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
